<!-- <ion-header [translucent]="true">
<ion-toolbar>
  <ion-buttons slot="start">
    <ion-menu-button></ion-menu-button>
  </ion-buttons>
  <ion-title>issue-award</ion-title>
</ion-toolbar>
</ion-header> -->
<ion-content [fullscreen]="true">
  <div>
    <ion-grid>
      <ion-row>
        <ion-col>
          <!-- Main content wrapper starts here -->
          <div class="ion-align-self-center main-container">
            <ion-text class="award-claim">
              <!-- App heading and description starts here -->
              <div class="ion-text-center  ion-margin-top"> <img class="check-icon" src="assets/images/check.svg"
                alt="Success"><!-- Succes Image -->
              </div>
              <h1>{{'issue-award.Claim' | translate}}</h1>
              <p>{{'issue-award.Click' | translate}}</p>
            </ion-text>
            <!-- App heading and description closed here -->

            <!-- App button starts here -->
            <ion-button (click)="navigateToRegistrationDefault()" class="button-1" expand="block">@if (!spinnerAnimation && proceed) {
              <span
              >{{'issue-award.button' | translate}}</span>
            }
            @if (spinnerAnimation) {
              <div class="spinners">
                <mat-progress-spinner mode="determinate" value="100" class="track-spinner" diameter="40">
                </mat-progress-spinner>
                <mat-progress-spinner class="spinner-circle" mode="determinate" [value]="progressBar" diameter="40">
                </mat-progress-spinner>
              </div>
            }
            @if (!proceed) {
              <mat-icon [@bounceIn] class="tick-mark">done</mat-icon>
            }
          </ion-button>
        </div>
        <!-- Main content wrapper closed here -->
      </ion-col>
    </ion-row>
  </ion-grid>
</div>
</ion-content>